// Shared layout styles used by App.js. (Other style objects that previously
// lived here were dead code and have been removed; components style inline or
// via the design tokens in ./tokens.)
import { color } from './tokens';

export const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: color.bg.base
  },
  main: {
    maxWidth: '80rem',
    margin: '0 auto',
    padding: '2rem 1rem'
  }
};
